import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { isEmptyArray, isEmptyObject, isStringEmpty, parseEmptyArray, stringEmptyDefault } from '@common/helpers';
import { EXTERNAL_SITE_CATEGORY_BIZ_MNT, FEATURE_TO_ROUTE_MAPPING } from '@common/helpers/constants/servicing.contant';
import { MyBookingTabShow } from '@common/helpers/enums/servicing.enum';
import {
  PREVIOUS_PAGE_IDENTIFIER,
  ServicingCommonModel,
  ServicingFunctionIdType,
  ServicingPageIdType,
} from '@common/interfaces';
import { FrequentFlyerCards } from '@common/interfaces/frequent-flyer-cards';
import { MFucntionIneligibleReason } from '@common/interfaces/master/m_function_ineligble_reason';
import { MNdcOffice } from '@common/interfaces/master/m_ndc_office';
import { MOldAndNewErrorMapping } from '@common/interfaces/master/m_old_and_new_error_mapping';
import { MPaymentInformation } from '@common/interfaces/master/m_payment_information';
import { OfficeByOffceCodeInfo } from '@common/interfaces/master/office_by offce_code';
import {
  MyBooking,
  MyBookingInitializeParams,
  TransitInfoPassenger,
  UnEnrolledPassenger,
} from '@common/interfaces/mybooking/mybooking.interface';
import { LOAD_MASTERS } from '@common/master/master';
import { BookingListStoreService } from '@common/services/booking-list/booking-list-store.service';
import { BookingSearchStoreService } from '@common/services/booking-search/booking-search-store.service';
import { GetOrderStoreService } from '@common/services/my-booking/get-order-store/get-order-store.service';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { NextActionTypeEnum, ROUTING_SCREEN } from '@common/services/next-action/next-action.constants';
import { NextActionService } from '@common/services/next-action/next-action.service';
import { ServicingCommonStoreService } from '@common/services/servicing-common-store/servicing-common-store.service';
import { updateGetFareConditions } from '@common/store/get-fare-conditions/get-fare-conditions.actions';
import { SupportPageComponent } from '@lib/components/support-class/support-page-component';
import { ApiCommonRequest, AswContextModel, TealiumDataKey, TealiumMode } from '@lib/interfaces';
import { AlertType } from '@lib/interfaces/alert-message-item';
import { AnaBizLoginStatusType } from '@lib/interfaces/ana-biz-login-status';
import { ApiErrorResponseModel } from '@lib/interfaces/api-error-response';
import { AswContextType } from '@lib/interfaces';
import { ErrorType } from '@lib/interfaces/errors';
import { LogType } from '@lib/interfaces/logger-datadog';
import { PageType } from '@lib/interfaces/page';
import { SessionStorageName } from '@lib/interfaces/session-storage-name';
import { StaticMsgPipe } from '@lib/pipes/static-msg/static-msg.pipe';
import { AswMasterService } from '@lib/services/asw-master/asw-master.service';
import { CommonLibService } from '@lib/services/common-lib/common-lib.service';
import { ErrorsHandlerService } from '@lib/services/errors-handler/errors-handler.service';
import { LoggerDatadogService } from '@lib/services/logger-datadog/logger-datadog.service';
import { ModalService } from '@lib/services/modal/modal.service';
import { PageInitService } from '@lib/services/page-init/page-init.service';
import { TealiumService } from '@lib/services/tealium/tealium.service';
import { AswCommonState } from '@lib/store';
import { Store } from '@ngrx/store';
import { Subscription, firstValueFrom, forkJoin, map, of, take } from 'rxjs';
import { AuthorizationApiService, AutoAuthorizationRequest } from 'src/sdk-authorization';
import {
  FareConditionsRequest,
  GetOrderRequest,
  GetOrderResponse,
  GetOrderResponseData,
  GetOrderResponseDataAir,
  DefaultService as ServicingApiService,
  Traveler,
  GetOrderResponseDataOrderType,
} from 'src/sdk-servicing';
import { UserApiService } from 'src/sdk-user';
import { ServicingSeatmapStoreService } from '@common/services/seatmap/servicing-seatmap-store.service';
import { ServicingSeatmapBackupStoreService } from '@common/services/seatmap/servicing-seatmap-backup-store.service';
import { ServiceRequestPaymentInputService } from '@common/services/service-request-payment-input/service-request-payment-input-service';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { BrowserNavigationService } from '@common/services';
import { createResponseName } from '@common/helper';
import { BehaviorSubject } from 'rxjs';
import { NotRetryableErrorModel } from '@lib/interfaces';
import { AppConstants } from '@conf/app.constants';
import { ErrorCodeConstants } from '@conf/app.constants';

interface CheckTermsAndConditionsModal {
  displayTermAndCondition: boolean;
  explainAPF: boolean;
  explainPNR: boolean;
  afterRedirectOffice: OfficeByOffceCodeInfo;
}

const MY_BOOKING_MASTER_DATA_LIST = [
  LOAD_MASTERS.M_NDC_OFFICE,
  LOAD_MASTERS.OFFICE_BY_OFFICE_CODE,
  LOAD_MASTERS.FUNCTION_INELIGIBLE_REASON_PK,
  LOAD_MASTERS.BANK_LANG,
  LOAD_MASTERS.M_PAYMENT_INFORMATION,
  LOAD_MASTERS.M_OLD_AND_NEW_ERROR_MAPPING,
  LOAD_MASTERS.BANK_ALL,
  LOAD_MASTERS.OFFLINEOFFICE_CITYCODE,
];

type IMyBookingMasterData = [
  Array<MNdcOffice>,
  OfficeByOffceCodeInfo,
  MFucntionIneligibleReason,
  Array<MPaymentInformation>,
  MOldAndNewErrorMapping
];

@Component({
  selector: 'asw-my-booking-cont',
  templateUrl: './my-booking-cont.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GetOrderStoreService],
})
export class MyBookingContComponent extends SupportPageComponent {
  override autoInitEnd = false;
  pageId: string = ServicingPageIdType.MY_BOOKING;
  functionId: string = ServicingFunctionIdType.BOOKING_CONFIRMATION;
  _subscription: Subscription = new Subscription();
  private _pnr: GetOrderResponseData = {};
  private errorData$ = new BehaviorSubject<NotRetryableErrorModel>({ errorType: ErrorType.BUSINESS_LOGIC });
  // 定数用
  public appConstants = AppConstants;

  constructor(
    private readonly _common: CommonLibService,
    private readonly _aswMasterService: AswMasterService,
    private readonly _pageInitService: PageInitService,
    private readonly _errorsHandlerSvc: ErrorsHandlerService,
    private readonly _store: Store,
    private readonly _router: Router,
    private readonly _myBookingService: MyBookingService,
    private readonly _myBookingStoreService: MyBookingStoreService,
    private readonly _myBookingServiceService: MyBookingServiceService,
    private readonly _servicingApiService: ServicingApiService,
    private readonly _modalService: ModalService,
    private readonly _bookingListStoreService: BookingListStoreService,
    private readonly _bookingSearchStoreService: BookingSearchStoreService,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly _tealiumSvc: TealiumService,
    private readonly _loggerDatadogService: LoggerDatadogService,
    private readonly _nextActionService: NextActionService,
    private readonly _userApiServie: UserApiService,
    private readonly _myBookingItineraryService: MyBookingItineraryService,
    private readonly _authorizationApiService: AuthorizationApiService,
    private readonly _titleService: Title,
    private readonly _staticMsg: StaticMsgPipe,
    private _servicingSeatmapStoreService: ServicingSeatmapStoreService,
    private _servicingSeatmapBackupStoreService: ServicingSeatmapBackupStoreService,
    private readonly _browserNavigationService: BrowserNavigationService,
    private _serviceRequestPaymentInputService: ServiceRequestPaymentInputService
  ) {
    super(_common, _pageInitService);
    this.callbackOnHandleRegisterEmail = this.callbackOnHandleRegisterEmail.bind(this);
    this.callbackOnHandleImmigrationInformationRegistration =
      this.callbackOnHandleImmigrationInformationRegistration.bind(this);
    this.callbackOnHandleAdvanceSeatSelection = this.callbackOnHandleAdvanceSeatSelection.bind(this);
    this.callbackOnHandleService = this.callbackOnHandleService.bind(this);
    this.callbackPassengerInformationRegistration = this.callbackPassengerInformationRegistration.bind(this);
    this.callbackBaggageRule = this.callbackBaggageRule.bind(this);
    this.callbackOnHandleMyCarValet = this.callbackOnHandleMyCarValet.bind(this);
  }

  init() {
    if (
      this._servicingCommonStoreService.servicingCommon.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.SEATMAP &&
      this._browserNavigationService.isBackOrforward()
    ) {
      // 「シートマップ画面（座席属性指定画面を含む）」から遷移、かつ、ブラウザバックの場合
      // 座席選択状態などはブラウザバック前（予約詳細遷移の時点）の内容を復元する
      this._servicingSeatmapStoreService.setServicingSeatmap(
        this._servicingSeatmapBackupStoreService.servicingSeatmapBackup
      );
      this._servicingSeatmapBackupStoreService.setServicingSeatmapBackup({});
    }

    this._nextActionService.registerCallbacks({
      callbackOnHandleRegisterEmail: this.callbackOnHandleRegisterEmail,
      callbackOnHandleImmigrationInformationRegistration: this.callbackOnHandleImmigrationInformationRegistration,
      callbackOnHandleAdvanceSeatSelection: this.callbackOnHandleAdvanceSeatSelection,
      callbackOnHandleMyCarValet: this.callbackOnHandleMyCarValet,
      callbackOnHandleService: this.callbackOnHandleService,
      callbackPassengerInformationRegistration: this.callbackPassengerInformationRegistration,
      callbackBaggageRule: this.callbackBaggageRule,
    });
    this._nextActionService.registerServicingCommonStoreService(this._servicingCommonStoreService);
    this._nextActionService.registerServicingSeatmapStoreService(this._servicingSeatmapStoreService);
    this._nextActionService.registerServicingSeatmapBackupStoreService(this._servicingSeatmapBackupStoreService);

    this._subscription.add(this._myBookingService.onInitSubject.subscribe(() => this.onInit()));

    this._subscription.add(
      this._errorsHandlerSvc.getNotRetryableError$().subscribe((errorData: NotRetryableErrorModel) => {
        this.errorData$.next(errorData);
      })
    );
  }

  callbackOnHandleService() {
    // 1. 予約詳細表示タブ変数 ≠ "service"の場合、    予約詳細表示タブ変数="service"(予約詳細(サービス))を設定する。
    if (this._myBookingService.tabShow !== MyBookingTabShow.MyBookingTabShowEnum.Service) {
      this._myBookingService.tabShow = MyBookingTabShow.MyBookingTabShowEnum.Service;
      // 2. [当画面共通処理No1.表示タブ切り替え処理]を行う。
      this._myBookingService.onHandleCommonNo1();
    }
  }

  callbackPassengerInformationRegistration(pnr: GetOrderResponseData = {}) {
    const { reservationDetailPreviousPage } = this._servicingCommonStoreService.servicingCommon;
    const routeList = ['R', 'C', 'E'];
    // Check whether was previously at Reservation, Checkin or Exchange module
    if (routeList.includes(reservationDetailPreviousPage?.functionId?.charAt(0) as string)) {
      // Due to nextAction param value PASSENGER_INPUT is shared used
      this.callbackOnHandleImmigrationInformationRegistration(pnr);
    } else {
      // Handle normally
      this._myBookingService.onHandlePassengerInformationRegistration(pnr);
    }
  }

  callbackOnHandleRegisterEmail(pnr: GetOrderResponseData = {}) {
    // 3.	上記以外の場合、[当画面共通処理No3.搭乗者情報入力モーダル表示処理]を行う。
    if (pnr.orderEligibilities?.travelerInput?.isEligible !== false) {
      this._myBookingService.onHandleCommonNo3();
    }

    // 提携: travelerInput.isEligible = false、かつINVOL(nextAction.acknowledgeOrSelfReaccommodation = true)の場合、搭乗者情報入力モーダル表示を行う。
    if (
      pnr.orderEligibilities?.travelerInput?.isEligible == false &&
      pnr.nextActions?.acknowledgeOrSelfReaccommodation == true
    ) {
      this._myBookingService.onHandleCommonNo3();
    }
  }

  callbackOnHandleImmigrationInformationRegistration(pnr: GetOrderResponseData = {}) {
    // 3.	上記以外の場合、[当画面共通処理No3.搭乗者情報入力モーダル表示処理]を行う。
    if (pnr.orderEligibilities?.travelerInput?.isEligible !== false) {
      this._myBookingService.onHandleCommonNo3();
    }
  }

  callbackOnHandleAdvanceSeatSelection(pnr: GetOrderResponseData = {}, displayTargetSegmentId = '') {
    if (pnr.orderEligibilities?.seatmap?.isEligible !== false) {
      // 2. 予約詳細store.規約からの再表示であるかにfalseを設定する。
      this.updateMyBooking({
        isReload: false,
      });
    }

    // 2.8.	対象セグメントIDが存在する場合、以下のパラメータでシートマップ画面(S03-P010)へ遷移する。
    if (displayTargetSegmentId) {
      this._servicingCommonStoreService.updateServicingCommon({ displayTargetSegmentId });
      this._router.navigate([ROUTING_SCREEN['S03-P010']]);
    }
    // 2.7.	対象セグメントIDが存在しない場合、
    else {
      // 2.7.1.	予約詳細表示タブ変数に"service"(予約詳細(サービス))を設定する。
      this._myBookingService.tabShow = 'service';
      // 2.7.2.	 [当画面共通処理.表示タブ切り替え処理]を行う。
      this._myBookingService.onHandleCommonNo1();
      // 2.7.3.	スクロール位置を予約詳細(サービス)(S01-P033)の画面.事前座席指定情報として、スクロールを行う。
      const scrollId = this._myBookingService.SCROLL_MAP.seatRequest;
      this._myBookingService.positionScrollId$.next(scrollId);
    }
  }

  callbackOnHandleMyCarValet(pnr: GetOrderResponseData = {}) {
    if (pnr.orderEligibilities?.myCarValet?.isEligible !== false) {
      this.updateMyBooking({
        isReload: false,
      });
    }
  }

  updateServicingCommon(servicingCommon: ServicingCommonModel) {
    this._servicingCommonStoreService.updateServicingCommon({ ...servicingCommon });
  }

  updateMyBooking(myBooking: MyBooking) {
    this._myBookingStoreService.updateMyBooking({ ...myBooking });
  }

  endOnInit() {
    this._myBookingService.finishInit();
    this._myBookingService.isApiCallMyBookingCompleted$.next(true);
  }

  /** 1.	画面の初期化処理(G01-003)の初期化開始処理を呼び出す。*/
  screenInit(servicingCommon: ServicingCommonModel) {
    const identificationId = sessionStorage.getItem(SessionStorageName.IDENTIFICATION_ID);
    this._loggerDatadogService.info(LogType.PAGE_VIEW, {
      identificationId,
      functionId_pageId: `${this.functionId}_${this.pageId}`,
    });
    // 画面情報JSONについて、下記の通りに設定する。(※：画面上に表示しない)
    this._tealiumSvc.setTealiumPageOutput({
      isFirstDisplay: servicingCommon.isFirstDisplay,
      completedFunction: servicingCommon.completedFunction,
    });
    this._myBookingService.isApiCallMyBookingCompleted$.next(false);
  }

  /** (1) 初期表示 */
  onInit() {
    this._subscription.add(
      forkJoin([
        this._common.aswCommonStoreService.getAswCommon$().pipe(take(1)),
        this._common.aswServiceStoreService.getAswService$().pipe(take(1)),
        this._common.aswContextStoreService.getAswContext$().pipe(take(1)),
        this._myBookingStoreService.getMyBookingModel$().pipe(take(1)),
        this._servicingCommonStoreService.getServicingCommonModel$().pipe(take(1)),
        this._aswMasterService.load(MY_BOOKING_MASTER_DATA_LIST, true).pipe(
          map((res) => res as IMyBookingMasterData),
          take(1)
        ),
      ]).subscribe((response) => {
        const [
          aswCommon,
          aswService,
          aswContext,
          myBooking,
          servicingCommon,
          [mNdcOffice, officeByOffceCode, mFucntionIneligibleReason, mPaymentInformation, mOldAndNewErrorMapping],
        ] = response;
        this.screenInit(servicingCommon);

        const mofficeByOffceCode = Object.values(officeByOffceCode).map((value) => value?.[0]);
        this._myBookingService.myBookingMasterData$.next({
          mNdcOffice: parseEmptyArray(mNdcOffice),
          officeByOffceCode: parseEmptyArray(mofficeByOffceCode),
          mFucntionIneligibleReason,
          mPaymentInformation: parseEmptyArray(mPaymentInformation),
          mOldAndNewErrorMapping,
        });

        this.onInitStep1({
          aswCommon,
          aswContext,
          myBookingState: {
            ...myBooking,
            /**
             * 予約番号変数
             * 1.予約詳細store.予約番号が存在する、予約詳細store.予約番号を設定する。
             * 2.上記以外の場合、サービス共通.予約番号を設定する。
             */
            orderId: myBooking.orderId || aswService.orderId,
            /**
             * 航空券番号変数
             * 1.予約詳細store.航空券番号が存在する、予約詳細store.航空券番号を設定する。
             * 2.上記以外の場合、サービス共通.航空券番号を設定する。
             */
            travelDocumentId: myBooking.travelDocumentId || aswService.travelDocumentId,
            /**
             * 搭乗者(名)変数
             * 1.予約詳細store.名が存在する、予約詳細store.名を設定する。
             * 2.上記以外の場合、サービス共通.名を設定する。
             */
            firstName: myBooking.firstName || aswService.firstName,
            /**
             * 搭乗者(姓)変数
             * 1.予約詳細store.姓が存在する、予約詳細store.姓を設定する。
             * 2.上記以外の場合、サービス共通.姓を設定する。
             */
            lastName: myBooking.lastName || aswService.lastName,
            /**
             * 遷移元画面識別子リスト
             * 以下の値を遷移元画面識別子リストに保持する。
                "anaBizApplicationList",
                "myCarValetRequest",
                "petEasyTravelRequest",
                "juniorPilotRequest",
                "seatmap",
                "seatAttributeRequest",
                "informativeSeatmap",
                "bookingSearch",
                "bookingList",
                "mybooking",
                "mybookingItinerary",
                "mybookingPassenger",
                "mybookingService",
                "agreement",
                "loungeServiceRequest",
                "baggageRequest",
                "flightMeaRequest",
                "servicePaymentInformationInput",
                "servicePaymentCompleated",
                "passengerInformationInput",
                "login",
                "receiptSearch",
                "receiptSelect",
                "boardingCertificateSearch",
                "boardingCertificateSelect",
                "emdSearch",
                "emdSelect",
                "anabizUsageStatementSelect",
                "dutyFreePreorderGuidance",
                "yamatoBaggageGuidance",
                "reservationBasicInformationInput",
             */
            sourceScreenIdentifierList: Object.entries(PREVIOUS_PAGE_IDENTIFIER).map(([k, v]) => v) || [],
          } as MyBooking,
          servicingCommonModel: servicingCommon,
        });
      })
    );
  }

  setPageTitle() {
    // 3.2.	画面タイトルに以下の内容を設定する。
    const title = `${this._staticMsg.transform('label.reservationDetails')}${this._staticMsg.transform(
      'label.aswPageTitle'
    )}`;
    this._titleService.setTitle(title);
  }

  /** (1) 初期表示 _1 */
  onInitStep1(params: MyBookingInitializeParams) {
    const { aswCommon, servicingCommonModel, myBookingState } = params;
    const pnr: GetOrderResponseData = servicingCommonModel.getOrder ?? {};

    // 2.	直近の遷移元画面情報を保存するため以下に値を設定する。
    const FUNCTION_ID = 'S01';
    const PAGE_IDS = ['P030', 'P031', 'P032', 'P033'];
    const doHaveScreenInfomation = !!aswCommon.functionId && !!aswCommon.pageId;
    // 2.1.	画面情報が存在する かつ (画面情報.機能ID≠"S01"、 または 画面情報.画面ID≠("P030"、"P031"、"P032"、"P033"))の場合、
    if (doHaveScreenInfomation && (aswCommon.functionId !== FUNCTION_ID || !PAGE_IDS.includes(aswCommon.pageId!))) {
      this._myBookingService.transitionSourceFunctionId = aswCommon.functionId!;
      this._myBookingService.transitionSourcePageId = aswCommon.pageId!;
    }

    // Ancillary支払情報入力画面から、update-services実行後に遷移してきた場合
    if (
      doHaveScreenInfomation &&
      aswCommon.functionId == 'S02' &&
      aswCommon.pageId == 'P020' &&
      !this._serviceRequestPaymentInputService.isSubHeaderDisplayGoBack
    ) {
      // PNRをリセット
      this.updateServicingCommon({
        getOrder: {},
        isFirstDisplay: true,
      });
      // 予約詳細(サービス)(S01-P033)の[全サービスの編集情報破棄処理]を行う。
      this._myBookingServiceService.onHandleCommonNo3();
      // エラーメッセージ「E0108」を呼び出し、当処理を終了する。
      this._common.errorsHandlerService.setNotRetryableError({
        errorType: ErrorType.BUSINESS_LOGIC,
        errorMsgId: 'E0108',
      });
      return;
    }

    // 3.	以下の内容を設定する。
    // 3.1.	画面情報に以下の内容を設定する。
    this._common.aswCommonStoreService.updateAswCommon({
      functionId: this.functionId,
      pageId: this.pageId,
      subFunctionId: '',
      subPageId: '',
      isEnabledLogin: false,
      isUpgrade: false,
    });

    // 4. 当画面で保持する情報について、以下の内容を保持する。
    this.handleInitializingValues(aswCommon, myBookingState, servicingCommonModel, pnr);

    // 5. 遷移元でPNR情報取得API応答(マスキングなし)を取得している場合、PNR情報取得API応答(マスキングなし)を破棄する。

    // 6.1.	初回表示フラグ変数=true
    // 6.2.	サービシング共通.DxAPIリトリーブ要否フラグ(dxApiRetrieveFlg) = true
    // 6.3. ユーザ共通情報.言語情報≠予約詳細store.言語
    if (
      this._myBookingService.isFirstDisplay === true ||
      params?.servicingCommonModel?.dxApiRetrieveFlg === true ||
      this._common.aswContextStoreService.aswContextData.lang !== myBookingState.lang
    ) {
      // 6.	以下いずれかの条件に該当する場合、PNR情報取得API処理フラグ変数にtrueを設定する。
      this._myBookingService.PNRInfomationAquisitionFlag = true;
    }

    // 7. PNR情報取得API処理フラグ変数 = trueの場合、以下PNR情報取得API処理を並列で行う。
    if (this._myBookingService.PNRInfomationAquisitionFlag) {
      // PNR情報取得API処理
      // PNR情報取得API処理(マスキングなし)
      this.callGetOrders(params);
    } else {
      const getOrderResponse: GetOrderResponse = { data: pnr };
      const apiResKey = createResponseName('/orders/get-order', 'POST', getOrderResponse);
      const tealiumValue = {
        [apiResKey]: getOrderResponse,
      };
      this._tealiumSvc.setTealiumGlobalVariable(
        {
          key: TealiumDataKey.API_REPLY_OUTPUT,
          value: tealiumValue,
        },
        TealiumMode.ADD
      );

      // 8. 以下のいずれかの条件に該当する場合、対応するエラーメッセージを指定し、画面遷移元へ遷移する。
      this.onInitStep2_1(params, pnr);
    }
  }

  /**
   * 7.1.	PNR情報取得API処理を行う。
   *
   * 7.2.	PNR情報取得API処理(マスキングなし)を行う。
   */
  callGetOrders(params: MyBookingInitializeParams) {
    const { myBookingState, servicingCommonModel } = params;

    /** 7.2.1.	リクエスト情報 */
    const unmaskedGetOrderRequest = this.createUnmaskedGetOrderRequest(myBookingState);

    /** 本処理で取得したレスポンスを「PNR情報取得API応答(マスキングなし)」と記載する */
    const unmaskedGetOrderAPICall = this._servicingApiService.ordersGetOrderPost(unmaskedGetOrderRequest);

    /**
     * S01-P031 (10)「お気に入り登録」ボタン押下時
     * In case of F5 or lost session, favoriteBtnIsRegisted has no value and btn state is clickable.
     */
    this.updateMyBooking({ favoriteBtnIsRegistered: false });
    // 予約詳細storeから予約番号、航空券番号、姓、名を削除する。
    this._myBookingStoreService.updateMyBooking({
      orderId: undefined,
      travelDocumentId: undefined,
      firstName: undefined,
      lastName: undefined,
    });
    // 7.3.	レスポンス情報
    unmaskedGetOrderAPICall.subscribe({
      next: (res) => {
        this.handleGetOrdersResponses(res, params);
      },
      error: (err) => {
        this.handleGetOrderPostError(err, myBookingState);
      },
    });
  }

  /** 7.3.1.	PNR情報取得API処理の並列処理がすべて正常終了の場合 */
  handleGetOrdersResponses(res: GetOrderResponse, params: MyBookingInitializeParams) {
    const { servicingCommonModel, myBookingState } = params;
    const unmaskedGetOrderAPICall = res;
    const unmasked = unmaskedGetOrderAPICall.data ?? {};
    const getOrder = this._myBookingService.maskOrderForStore(unmasked);
    let newParams = { ...params };

    // 7.3.1.1.	サービス共通に以下の内容を設定する。
    const newOrderId = getOrder?.orderId;
    this._common.aswServiceStoreService.updateAswService({
      orderId: newOrderId,
      travelDocumentId: myBookingState.travelDocumentId,
      firstName: myBookingState.firstName,
      lastName: myBookingState.lastName,
    });

    newParams = { ...newParams, myBookingState: { ...myBookingState, orderId: newOrderId } };

    // 7.3.1.2.	PNR情報取得API応答について、サービシング共通storeに保持する。
    this.updateServicingCommon({ getOrder });
    //提携: ユーザ共通情報.言語情報を、予約詳細storeに保持する。
    const lang = this._common.aswContextStoreService.aswContextData.lang;
    this.updateMyBooking({ lang });

    // 7.3.1.3.	PNR情報取得API応答(マスキングなし)について、必要な情報を各種storeに更新する。
    this.handleUnmaskedGetOrderResponse(newParams, unmaskedGetOrderAPICall.data);

    // 8. 以下のいずれかの条件に該当する場合、対応するエラーメッセージを指定し、画面遷移元へ遷移する。
    this.onInitStep2_1({ ...newParams, servicingCommonModel: { ...servicingCommonModel, getOrder } }, getOrder);
  }

  handleInitializingValues(
    aswCommon: AswCommonState,
    myBookingState: MyBooking,
    servicingCommonModel: ServicingCommonModel,
    pnr: GetOrderResponseData
  ) {
    const isNotS02 = aswCommon.subFunctionId !== 'S02';
    const isNotM151617 = !['M015', 'M016', 'M017'].includes(aswCommon.subPageId as string);
    const isNotPageCallBackPNR: string[] = [
      PREVIOUS_PAGE_IDENTIFIER.BOOKING_SEARCH,
      PREVIOUS_PAGE_IDENTIFIER.BOOKING_LIST,
      PREVIOUS_PAGE_IDENTIFIER.MYBOOKING,
      PREVIOUS_PAGE_IDENTIFIER.AGREEMENT,
    ];

    /** Note: Use "previousPageIdentifier" instead of "reservationDetailPreviousPage?.functionId" */
    const previousFunctionId = stringEmptyDefault(servicingCommonModel?.previousPageIdentifier);
    // 1.以下のいずれ条件に該当する場合、trueを設定する。
    if (
      // 1.1.サービシング共通store.PNR情報取得API応答を保持していない
      isEmptyObject(pnr) ||
      // 1.2.サービス共通.予約番号が存在する、かつサービス共通.予約番号≠サービシング共通store.PNR情報取得API応答.data.orderId
      (myBookingState.orderId && myBookingState.orderId !== pnr.orderId) ||
      // 1.3.予約詳細.航空券番号が存在する、かつ予約詳細.航空券番号≠サービシング共通store.PNR情報取得API応答.data.travelDocuments[0].id
      (myBookingState.travelDocumentId && myBookingState.travelDocumentId !== pnr.travelDocuments?.[0]?.id) ||
      // 1.4.サービシング共通store.初回表示フラグ=true、かつ遷移元画面識別子リスト("bookingSearch"、"bookingList"、"agreement"、"mybooking"を含まない)にサービシング共通store.遷移元画面識別子が存在しない
      (servicingCommonModel.isFirstDisplay === true &&
        !myBookingState?.sourceScreenIdentifierList
          ?.filter((item) => !isNotPageCallBackPNR.includes(item))
          ?.some((item) => previousFunctionId === item)) ||
      // 1.5.遷移元機能ID+"-"+遷移元画面ID="S01-P020"(予約一覧画面)、かつサブ機能ID≠"S02"、かつサブ画面ID≠""("M015"、"M016"、"M017")
      (this._myBookingService.getTransitionSourceFullFunctionPageId() === 'S01-P020' && isNotS02 && isNotM151617) ||
      // 1.6.遷移元画面識別子リストにサービシング共通store.遷移元画面識別子が存在しない
      !myBookingState?.sourceScreenIdentifierList?.some((item) => previousFunctionId === item) ||
      // 1.7.サービス共通.予約番号が存在する、かつサービス共通.予約番号=サービシング共通store.PNR情報取得API応答.data.orderId、かつサービシング共通store.PNR情報取得API応答.orderType.isGroupBooking=true、かつ
      // サブ機能ID≠"S02"、かつサブ画面ID≠""("M015"、"M016"、"M017")
      (!!myBookingState.orderId &&
        myBookingState.orderId === pnr.orderId &&
        pnr.orderType?.isGroupBooking === true &&
        isNotS02 &&
        isNotM151617)
    ) {
      this._myBookingService.isFirstDisplay = true;
    } else {
      // 2.上記以外の場合、falseを設定する。
      this._myBookingService.isFirstDisplay = false;
    }

    // サービシング共通store.登録完了時機能種別が存在する場合、その登録完了時機能種別。そうでない場合、""(空欄)を設定する。
    this._myBookingService.completedFunction = servicingCommonModel.completedFunction ?? '';
    // サービシング共通store.予約詳細表示タブが存在する場合、予約詳細store.予約詳細表示タブ。そうでない場合、"itinerary"(予約詳細(旅程))を設定する。
    this._myBookingService.tabShow = servicingCommonModel.tabShow
      ? servicingCommonModel.tabShow
      : MyBookingTabShow.MyBookingTabShowEnum.Itinerary;
    // PNR情報取得API処理フラグ変数	falseを設定する。
    this._myBookingService.PNRInfomationAquisitionFlag = false;
  }

  onInitStep2_1(params: MyBookingInitializeParams, pnr: GetOrderResponseData) {
    const { aswContext, myBookingState } = params;
    // 8.1.	以下の条件でASWDB(マスタ)からプロパティ.valueを取得し、ANA Bizオフィスとして保持する。
    /** ANA Bizオフィス */
    const anaBizOffices = this._common.aswMasterService
      .getMPropertyByKey('application', 'anaBiz.officeCodes')
      .split('|');

    // 提携: 社用運賃PNRの場合にオフィスの切り替えを行う
    this.handleCheckconditionDisplayingTermsAndConstionsModal(params, pnr, anaBizOffices);
  }

  /** 9.1.	ANA Biz オートログインAPIを呼び出し、ANA Bizログインを行う。 */
  callAnabizAutoAuthorizationPost(
    pnr: GetOrderResponseData,
    myBookingState: MyBooking,
    asyncCallback: () => Promise<void>
  ) {
    // 9.1.1.	リクエスト情報
    const anabizAuthorizationRequest: AutoAuthorizationRequest = {
      orderId: pnr.orderId!,
      credential: {
        lastName: myBookingState.lastName!,
        firstName: myBookingState.firstName!,
      },
    };

    this._authorizationApiService
      .anaBizAutoAuthorizationPost(anabizAuthorizationRequest)
      // 9.1.2.	レスポンス情報
      .subscribe({
        // 9.1.2.1.	正常終了の場合
        next: async (res) => {
          const aswContext = (res.data.aswContext ?? {}) as Partial<AswContextModel>;
          const anaBizContext = res.data.anaBizContext ?? {};
          // 9.1.2.1.1.	取得したANA Biz オートログインAPI応答.data.aswContextのいずれ項目をユーザ共通情報の該当項目に更新する。
          this._common.aswContextStoreService.updateAswContext(aswContext);
          // 9.1.2.1.2.	取得したANA Biz オートログインAPI応答.data.anaBizContextのいずれ項目をANA Bizログイン情報の該当項目に更新する。
          this._common.anaBizContextStoreService.updateAnaBizContext(anaBizContext);
          // 9.1.2.1.3.	取得したANA Biz オートログインAPI応答.data.anaBizContext.encryption.anaBizAccessTokenをローカルストレージ.encryptedAnaBizAccessTokenに更新する。
          localStorage.setItem('encryptedAnaBizAccessToken', res.data.anaBizContext?.encryption?.anaBizAccessToken!);

          await asyncCallback();
        },
        // 9.1.2.2.	異常終了の場合
        error: (err) => {
          // 以下表の1行目から順に、ANA Biz オートログインAPI応答.errorsについて、当該error.コード=エラーコードとなるエラーコードが含まれるかを確認し、
          // 最初に含まれるエラーコードについて、そのエラーコードの行に応じたエラーメッセージIDを求める。
          const apiErrorCode = this._common.apiError?.errors?.[0]?.code ?? '';
          /** 9.1.2.2.1.	以下表のエラーコードは条件を問わず、いずれのエラーコードの行に応じたメッセージを記載する。*/
          const ANABIZ_AUTHORIZATION_ERROR_CODE_MAPPING: Record<string, string> = {
            /** "EBAZ000755"(企業情報が利用開始前である場合) => "E1139" */
            [ErrorCodeConstants.ERROR_CODES.EBAZ000755]: 'E1139',
            /** "EBAZ000756"(企業情報が失効後である場合) => "E1324" */
            [ErrorCodeConstants.ERROR_CODES.EBAZ000756]: 'E1324',
            /**"EBAZ000767"(企業情報の利用開始日が未設定である場合) => "E1785" */
            [ErrorCodeConstants.ERROR_CODES.EBAZ000767]: 'E1785',
            /** "EBAZ000754"(ANA Bizオートログイン不可PNRである場合) "E1786" */
            [ErrorCodeConstants.ERROR_CODES.EBAZ000754]: 'E1786',
          };
          const errorMsgId = ANABIZ_AUTHORIZATION_ERROR_CODE_MAPPING[apiErrorCode];
          // 9.1.2.2.2.	エラーメッセージIDがある場合、以下の情報を設定する。
          this._common.errorsHandlerService.setNotRetryableError({
            errorType: ErrorType.BUSINESS_LOGIC,
            errorMsgId,
            apiErrorCode,
          });
        },
      });
  }

  handleAnabizOfficeError(errorMessageId: string, myBookingState: MyBooking) {
    const previousPage = this._myBookingService.getTransitionSourceFullFunctionPageId();
    switch (previousPage) {
      // 8.4.1.	以下の値を遷移元機能ID="S01"、遷移元画面ID="P010"(予約検索)の場合、予約検索storeに保持し、予約検索(S01-P010)へ遷移する。
      case 'S01-P010':
        this._bookingSearchStoreService.updateBookingSearch({ errorMessageList: [{ errorMsgId: errorMessageId }] });
        this._router.navigateByUrl(FEATURE_TO_ROUTE_MAPPING[previousPage]);
        break;
      default:
        // 8.4.3.	上記以外の場合、以下の値をNotRetryableErrorStoreに保持し、共通エラー画面へ遷移する。
        this._common.errorsHandlerService.setNotRetryableError({
          errorType: ErrorType.BUSINESS_LOGIC,
          errorMsgId: errorMessageId,
        });
        break;
    }
    this.endOnInit();
  }

  async handleCheckconditionDisplayingTermsAndConstionsModal(
    params: MyBookingInitializeParams,
    pnr: GetOrderResponseData,
    anabizOfficeCodes: string[]
  ) {
    const { aswContext, myBookingState } = params;
    // 10.	＜以下、規約(S01-M034)をモーダルで表示する条件チェック＞
    // 10.1.	リダイレクト後操作オフィス情報を取得するため、下記の処理を行う。
    // 10.1.1.	リダイレクト後操作オフィス情報のオブジェクトを作成する。

    // 10.1.2.	PNR種別を取得する。
    /** PNR種別 */
    const [PNR_type, paidInternalCategory] = this._myBookingService.getPNRTypeAndPaidInternalCategory(pnr);

    // 10.1.3.	切り替え先オフィスを取得する。
    /** リダイレクト後操作オフィス */
    const afterRedirectOffice = await this._myBookingService.getRedicrectOfficeObject(
      aswContext,
      anabizOfficeCodes,
      PNR_type,
      paidInternalCategory,
      pnr
    );

    // 10.2.	予約詳細store.第3言語コードにリダイレクト後操作オフィス情報.第3言語コードを設定する。
    const lang3rd = afterRedirectOffice?.third_language_code;
    this.updateMyBooking({ lang3rd });

    // 10.3.	リダイレクト後操作オフィス情報が取得できた場合
    if (afterRedirectOffice) {
      // 10.3.1.	ユーザ共通.POS国コード(2レター)≠リダイレクト後操作オフィス情報.POS国コードの場合、規約表示要否にtrueを設定する。
      // それ以外の場合、規約表示要否にfalseを設定する。
      /** 規約表示要否 */
      // 提携ではPOS国コードが変わらないのでfalseの固定値を設定
      let displayTermAndCondition = false;
      // 10.3.2.	ユーザ共通.操作オフィスコード ≠ "TYONH08AP"(APFサイト)、
      // かつ PNR情報取得API応答.data.creationPointOfSale.pointOfSaleId= "TYONH08AP"(APFサイト)の場合、APF説明表示要否にtrueを設定する。
      // それ以外の場合、APF説明表示要否にfalseを設定する。
      const codeCompare = 'TYONH08AP';
      /** APF説明表示要否 */
      // 提携ではAPF説明表示は行わないためfalseの固定値を設定
      const explainAPF = false;
      // 10.3.3.	ユーザ共通.操作オフィスコード ≠ PNR情報取得API応答.data.servicingPointOfSale.pointOfSaleId かつ
      // ユーザ共通.操作オフィスコードの上7桁 ≠ リダイレクト後操作オフィス情報.オフィスコードの上7桁の場合、PNR説明表示要否にtrueを設定する。
      // それ以外の場合、PNR説明表示要否にfalseを設定する。
      const getFirst7Char = (str?: string) => (str ?? '').substring(0, 7);
      /** PNR説明表示要否 */
      // 規約画面の表示を行わないためfalseの固定値を設定
      const explainPNR = false;

      /** 10.3.4 ユーザ共通情報.言語情報≠("ja"(日本語)、かつ"en"(英語))、かつ以下いずれかの条件に該当する場合、規約表示要否にtrueを設定する。
       * 10.3.4.1.	予約詳細store.第3言語コードが存在しない
       * 10.3.4.2.	ユーザ共通情報.言語情報 ≠ 予約詳細store.第3言語コード */
      if (
        this._common.aswContextStoreService.aswContextData.lang !== 'ja' &&
        this._common.aswContextStoreService.aswContextData.lang !== 'en' &&
        (isStringEmpty(lang3rd) || this._common.aswContextStoreService.aswContextData.lang !== lang3rd)
      ) {
        displayTermAndCondition = true;
      }

      if (displayTermAndCondition || explainAPF || explainPNR) {
        // 10.3.5.	規約表示要否=true、または APF説明表示要否=true、または PNR説明表示要否=trueの場合
        this.handleDisplayingTermsAndConditionsModal({
          displayTermAndCondition,
          explainAPF,
          explainPNR,
          afterRedirectOffice,
        });
        return;
      }
      // 10.3.6.	上記以外 かつ ユーザ共通.操作オフィスコード ≠ リダイレクト後操作オフィス情報.オフィスコードの場合
      // 提携: 社用運賃PNRの場合はここでオフィス切り替えを行う
      else if (params.aswContext.pointOfSaleId !== afterRedirectOffice?.office_code) {
        this.callChangeOfficeAndLangPost(afterRedirectOffice);
        return;
      }
    }

    this.onInitStep2_2(params, pnr);
  }

  handleDisplayingTermsAndConditionsModal(values: CheckTermsAndConditionsModal) {
    const { displayTermAndCondition, explainAPF, explainPNR, afterRedirectOffice } = values;
    // 10.3.5.1.	以下の値を予約詳細storeに保持する。
    this.updateMyBooking({
      displayTermAndCondition,
      explainAPF,
      explainPNR,
      officeInfoAfterRedirectCode: afterRedirectOffice.office_code,
    });
  }

  callChangeOfficeAndLangPost(afterRedirectOffice: OfficeByOffceCodeInfo) {
    // 10.3.6.1.	ASWDB(Tx)のS2パーソナライズ情報を更新するために、以下の内容でオフィス/言語変更APIを呼び出す。
    // 10.3.6.1.1.	リクエスト情報
    this._userApiServie
      .changeOfficeAndLangPost({
        // リダイレクト後操作オフィス情報.オフィスコード
        pointOfSaleId: afterRedirectOffice.office_code,
      })
      .pipe(take(1))
      // 10.3.6.1.2.	レスポンス情報
      .subscribe({
        // 10.3.6.1.2.1.	正常終了の場合
        next: (res) => {
          // ユーザ共通を、オフィス/言語変更APIからのユーザ共通情報で上書きする。
          const aswContext = (res.data?.aswContext ?? {}) as Partial<AswContextModel>;
          aswContext && this._common.aswContextStoreService.updateAswContext(aswContext);
          // 予約詳細画面の再表示フラグにtrueを設定する。
          this._myBookingService.refreshFlag = true;
          this.handleReRunInit();
        },
        // 10.3.6.1.2.2. APIが一般的なエラーを返す場合、「共通機能 エラーハンドリング(SPA)(G01-009)」を呼び出し、初期表示処理を終了する。
        error: (error) => {
          this.endOnInit();
          this._common.errorsHandlerService.setNotRetryableError({
            errorType: ErrorType.SYSTEM,
          });
        },
      });
  }

  handleReRunInit() {
    // 10.3.7.	予約詳細画面の再表示フラグ=trueの場合、予約詳細画面の再表示を行う。
    if (this._myBookingService.refreshFlag) {
      // 10.3.7.1.	以下の通りに設定して、初期表示を再実施する。
      this.updateServicingCommon({
        getOrder: {},
        isFirstDisplay: true,
      });
      this._myBookingService.runOnInit();
    }
    // ＜ここまで、規約(S01-M034)をモーダルで表示する条件チェック＞
  }

  onInitStep2_2(params: MyBookingInitializeParams, pnr: GetOrderResponseData) {
    // ANAUIUXS2_DEV-19647 - RM#42897
    this._common.aswServiceStoreService.updateAswService({
      firstName: params.myBookingState.firstName?.toUpperCase(),
      lastName: params.myBookingState.lastName?.toUpperCase(),
    });

    // 11.	サービス共通.予約番号が空の場合、サービス共通に以下の内容を設定する。
    if (!params.myBookingState.orderId)
      this._common.aswServiceStoreService.updateAswService({
        orderId: pnr.orderId,
      });

    // all: 機内食情報取得APIの削除によりここで下記メソッドを呼び出す
    this.onInitStep2_3(params, pnr);
  }

  async onInitStep2_3(params: MyBookingInitializeParams, pnr: GetOrderResponseData) {
    const { servicingCommonModel } = params;

    // 13.	PNR情報取得API応答.data.air.isContainedInfantQuotaShortageSegment = true(搭乗可能なINF数を超えたセグメント有)の場合、
    if (pnr.air?.isContainedInfantQuotaShortageSegment === true) {
      // 旅程中に幼児搭乗者数の制限を超え予約できない便が含まれるため、別の便を選択する必要がある旨のワーニングを表示する。
      this._common.alertMessageStoreService.setAlertWarningMessage({
        contentHtml: 'E1140',
        isCloseEnable: true,
        alertType: AlertType.WARNING,
        errorMessageId: 'E1140',
      });
    }

    // 14.	サービシング共通store.予約詳細遷移元画面区分 = ""(空欄) または 存在しない場合、
    if (!servicingCommonModel.reservationDetailPreviousPage) {
      // サービシング共通store.予約詳細遷移元画面区分に遷移元機能ID + "-" + 遷移元画面IDを設定する。
      this.updateServicingCommon({
        reservationDetailPreviousPage: {
          functionId: this._myBookingService.transitionSourceFunctionId,
          pageId: this._myBookingService.transitionSourcePageId,
        },
      });
    }

    await this.onInitStep3(params, pnr);
  }

  async onInitStep3(params: MyBookingInitializeParams, pnr: GetOrderResponseData) {
    const { servicingCommonModel } = params;
    // 15.1.	チェックインサービス申込に初期値としてfalseを設定する。
    const checkInServiceApplication =
      // 15.2.	以下条件全てに該当する場合、チェックインサービス申込にtrueを設定する。
      // 15.2.1.サービシング共通store.予約詳細遷移元画面区分の1文字目 = "C"(チェックイン機能)
      // 15.2.2.	サービシング共通store.次に行うアクション= ”SERVICE” (予約詳細(サービス))
      stringEmptyDefault(servicingCommonModel?.reservationDetailPreviousPage?.functionId)?.startsWith('C') &&
      servicingCommonModel?.nextAction === NextActionTypeEnum.Service;
    // 15.	チェックイン機能からサービス申込を行う為に当画面へ遷移してきたかどうかを判定し、結果を予約詳細storeに保持する。
    this.updateMyBooking({
      checkInServiceApplication,
    });

    // 16.	画面用再表示変数を初期化する
    // 16.2.	サービシング共通store.初回表示フラグにfalseを設定する。
    // 16.3.	を設定する。サービシング共通.DxAPIリトリーブ要否フラグ(dxApiRetrieveFlg) = false」を設定する
    this.updateServicingCommon({
      isFirstDisplay: false,
      dxApiRetrieveFlg: false,
    });

    // 17.	連携メッセージIDを表示する。
    await this.handleMyBookingErrorsAndWarnings(params);

    this.onInitStep4(params, pnr);
  }

  async handleMyBookingErrorsAndWarnings(params: MyBookingInitializeParams) {
    const { servicingCommonModel, myBookingState } = params;
    // 17.1.	サービシング共通store.エラーメッセージが存在する場合、予約詳細store.エラーメッセージにて継続可能なエラー情報を指定し、当画面にてエラーメッセージを表示する。
    const errorMessage = servicingCommonModel.preErrorMessage;
    if (errorMessage) {
      this._errorsHandlerSvc.setRetryableError(PageType.PAGE, {
        errorMsgId: errorMessage.errorMsgId,
        apiErrorCode: errorMessage.apiErrorCode,
        params: errorMessage.params,
      });
    }
    // 17.2.	サービシング共通store.ワーニングメッセージリストが存在する場合、当画面にてワーニングメッセージ表示する。
    const warningMessageList = servicingCommonModel.preWarningMessageList;
    if (warningMessageList?.length) {
      warningMessageList?.forEach((warningMessage) => {
        this._common.alertMessageStoreService.setAlertWarningMessage(warningMessage);
      });
    }

    // 17.4.	連携エラー情報をリセットする。
    // 17.4.1.	予約詳細store.エラーメッセージIDに""(空欄)を設定する。
    // 17.4.2.	予約詳細store.ワーニングメッセージリストに""(空欄)を設定する。
    this.updateServicingCommon({
      preErrorMessage: undefined,
      preWarningMessageList: undefined,
    });

    // 17.4.3.	予約詳細store.国際ASWエラーIDに""(空欄)を設定する。
    this.updateMyBooking({
      aswIntErrorId: undefined,
    });
  }

  /** 未入会搭乗者有無 */
  hasUnEnrolledPassengers(pnr?: GetOrderResponseData) {
    // 未入会搭乗者有無=false(未入会搭乗者なし)とする。
    let flag = false;
    // ＜以下、PNR情報取得API応答.data.travelers(リスト)の件数分繰り返し＞
    for (const traveler of pnr?.travelers ?? []) {
      // PNR情報取得API応答.data.frequentFlyerCards.<当該travelers.id>.isAmcMember=false(AMC会員でない)の場合、
      if ((pnr?.frequentFlyerCards as FrequentFlyerCards)?.[traveler?.id as string]?.isAmcMember === false) {
        // 未入会搭乗者有無=true(未入会搭乗者あり)を設定し、繰り返しを終了する。
        flag = true;
        break;
      }
    }
    // ＜ここまで、PNR情報.data.travelers(リスト)の件数分繰り返し＞
    return flag;
  }

  handleUnmaskedGetOrderResponse(params: MyBookingInitializeParams, pnr: GetOrderResponseData = {}) {
    // 7.3.1.2.1.	予約詳細store.未入会搭乗者の初期化処理
    /** 未入会搭乗者有無 */
    const hasUnEnrolledPassengers = this.hasUnEnrolledPassengers(pnr);
    // 未入会搭乗者有無=trueの場合、以下処理にて、未入会搭乗者に関する情報を作成し、予約詳細storeに保持する。
    if (hasUnEnrolledPassengers) {
      // 未入会搭乗者情報を以下内容のオブジェクトとする。
      let unEnrolledPassengers: UnEnrolledPassenger[] = [];
      // 7.3.1.2.2.	予約詳細store.未入会搭乗者の更新処理
      // 未入会搭乗者有無=trueの場合、PNR情報取得API応答(マスキングなし).data.travelersの件数分繰り返し、下記の処理を行う。
      // カウンタを初期値0とする。
      pnr?.travelers?.forEach((traveler) => {
        // PNR情報取得API応答(マスキングなし).data.frequentFlyerCards.<当該travelers.id>.isAmcMember=false(AMC会員でない)の場合
        if ((pnr?.frequentFlyerCards as FrequentFlyerCards)?.[traveler.id as string]?.isAmcMember === false) {
          const passenger = this.getNoMaskingTraveler(traveler, pnr);
          unEnrolledPassengers = [...unEnrolledPassengers, passenger];
        }
        // カウンタをインクリメントし、travelersの次レコード処理に進む。
      });
      this.updateMyBooking({ unEnrolledPassengers: unEnrolledPassengers });
    } else {
      this.updateMyBooking({ unEnrolledPassengers: [] });
    }

    // 7.3.1.2.3.	サービシング共通store.代表者メールアドレスの更新処理
    // PNR情報取得API応答(マスキングなし).data.contacts.representative.emails[0].addressを設定する。
    this.updateServicingCommon({
      representativeMail: pnr?.contacts?.representative?.emails?.[0]?.address,
    });

    // 7.3.1.2.4.	予約詳細store.トランジット情報の更新処理
    const transitInfo = this.getTransitInformationForPassenger(pnr);
    this.updateMyBooking({ transitInfo });

    // 7.3.1.2.5. 予約詳細store.搭乗者情報系サポートの更新処理
    const travelerSupports = pnr?.travelerSupports ?? {};
    this.updateMyBooking({ travelerSupports });

    // 7.3.1.2.6.	PNR情報取得API応答(マスキングなし)を破棄する。
  }

  getTransitInformationForPassenger(pnr?: GetOrderResponseData) {
    let transitInfoPassenger: TransitInfoPassenger = {};
    // ＜以下、PNR情報取得API応答(マスキングなし).data.travelers[]の要素数繰り返し＞(それぞれの要素が当該搭乗者情報)
    pnr?.travelers?.forEach((traveler) => {
      // 当該搭乗者情報に対して、以下の処理でisTransitを設定し、キーは当該搭乗者情報.idとして要素をトランジット情報リストに追加する。
      // 当該搭乗者情報.regulatoryDetails.destinationAddresses[]の全て要素のisTransit=trueの場合、isTransit=trueを設定する。
      // 上記以外の場合、isTransit=falseを設定する。
      const isNotTransit = traveler?.regulatoryDetails?.destinationAddresses?.some(
        (item) => Boolean(item?.isTransit) === false
      );
      if (isNotTransit || isEmptyArray(traveler?.regulatoryDetails?.destinationAddresses)) {
        transitInfoPassenger[`${traveler?.id}`] = { isTransit: false };
      } else {
        transitInfoPassenger[`${traveler?.id}`] = { isTransit: true };
      }
    });
    // ＜ここまで、PNR情報取得API応答(マスキングなし).data.travelers[]の要素数繰り返し＞
    return transitInfoPassenger;
  }

  getNoMaskingTraveler(traveler: Traveler, pnr: GetOrderResponseData): UnEnrolledPassenger {
    const passenger: UnEnrolledPassenger = {};
    // 未入会搭乗者情報[カウンタ].搭乗者IDに、当該travelers.idを設定する。
    passenger['id'] = traveler.id;
    // 未入会搭乗者情報[カウンタ].搭乗者敬称に、当該travelers.names[0].title
    passenger['title'] = `${traveler.names?.[0]?.title}`;
    // 未入会搭乗者情報[カウンタ].搭乗者姓に、当該travelers.names[0].lastName
    passenger['lastName'] = `${traveler.names?.[0]?.lastName}`;
    // 未入会搭乗者情報[カウンタ].搭乗者名に、当該travelers.names[0].firstName
    passenger['firstName'] = `${traveler.names?.[0]?.firstName}`;
    const GENDERS: Record<string, string> = {
      // 当該travelers.gender=”male”の場合、”M”を設定する。
      male: 'M',
      // 当該travelers.gender=”female”の場合、”F”を設定する。
      female: 'F',
    };
    // 未入会搭乗者情報[カウンタ].性別に、当該travelers.genderに応じた値を設定する。
    // 当該travelers.genderが上記以外の場合、””(空欄)を設定する。
    passenger['gender'] = GENDERS[traveler.gender as string] ?? '';
    // 未入会搭乗者情報[カウンタ].生年月日に、当該travelers.dateOfBirth(yyyy/MM/dd形式)を設定する。
    passenger['dateOfBirth'] = traveler.dateOfBirth;
    // 未入会搭乗者情報[カウンタ].メールアドレスに、
    // PNR情報取得API応答(マスキングなし).data.contacts.<当該travelers.id>.emails[0].addressを設定する。
    passenger['mail'] = pnr?.contacts?.[traveler.id as string]?.emails?.[0]?.address;
    // 未入会搭乗者情報[カウンタ].居住国に、以下条件に従い値を保持する。
    // PNR情報取得API応答(マスキングなし).data.air.tripType=international(国際旅程)の場合、
    if (pnr?.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.International) {
      // PNR情報取得API応答(マスキングなし).data.当該Travelers.regulatoryDetails.homeAddressCountries[0].codeを設定する。
      passenger['country'] = traveler.regulatoryDetails?.homeAddressCountries?.[0]?.code;
    } else {
      // 上記以外の場合、””(空欄)を設定する。
      passenger['country'] = '';
    }
    return passenger;
  }

  async onInitStep4(params: MyBookingInitializeParams, pnr: GetOrderResponseData) {
    const { servicingCommonModel, myBookingState } = params;

    // 18.	画面表示内容、「表示内容 処理No1」シートに従い設定する。

    // 19.	サービシング共通store.初期表示サービスが存在する場合、以下の内容にて初期表示サービス位置指定処理を行う。
    const initDisplayService = servicingCommonModel.initDisplayService;
    if (initDisplayService) {
      // 19.1.	予約詳細表示タブ変数="service"(予約詳細(サービス))を設定する。
      this._myBookingService.tabShow = MyBookingTabShow.MyBookingTabShowEnum.Service;
      // 19.2. [当画面共通処理.表示タブ切り替え処理]を行う。
      await this._myBookingService.onHandleCommonNo1();

      const SCROLL_MAP = this._myBookingService.SCROLL_MAP;
      const scrollId =
        this._myBookingService.SCROLL_MAP[initDisplayService as keyof typeof SCROLL_MAP] ??
        // 19.10.	上記以外の場合(利用不可)、スクロール位置を予約詳細(サービス)(S01-P030)のヘッダ部として、スクロールを行う。
        this._myBookingService.SCROLL_MAP.myBookingHeader;

      this._myBookingService.positionScrollId$.next(scrollId);
    } else {
      this._myBookingService.positionScrollId$.next('');
    }

    // 20.	サービシング共通store.初期表示サービスが存在せず、かつサービシング共通store.次に行うアクションが存在する
    // かつ 予約詳細store.次に行うアクション実施済み有無=false(未実施)の場合、以下内容に従い、該当する処理を行う。
    if (
      !servicingCommonModel.initDisplayService &&
      servicingCommonModel.nextAction &&
      !myBookingState.nextActionImplemented
    ) {
      this.handleNextAction(params?.servicingCommonModel?.nextAction as NextActionTypeEnum, pnr);
    }

    // 21.	サービシング共通store.初期表示サービスが存在しない、かつサービシング共通store.次に行うアクションが存在しない場合、以下の処理にて画面を表示する。
    // 提携：「SPA跨ぎで画面遷移後、戻るボタンで予約詳細画面を表示したときローディングが解除されない」対応
    // if (!servicingCommonModel.initDisplayService && !servicingCommonModel.nextAction) {
    //   // [当画面共通処理.表示タブ切り替え処理]を行う。
    //   this._myBookingService.onHandleCommonNo1();
    // }
    // 21.	サービシング共通store.初期表示サービスが存在しない
    if (!servicingCommonModel.initDisplayService) {
      // サービシング共通store.次に行うアクションが存在しない場合、以下の処理にて画面を表示する。
      if (!servicingCommonModel.nextAction) {
        // [当画面共通処理.表示タブ切り替え処理]を行う。
        this._myBookingService.onHandleCommonNo1();
      } else {
        //  提携：表示するtabActiveが決まっていないが場合
        if (!this._myBookingService.tabActive) {
          // サービシング共通store.予約詳細表示タブが存在する場合、予約詳細store.予約詳細表示タブ。そうでない場合、"itinerary"(予約詳細(旅程))を設定する。
          this._myBookingService.tabShow = servicingCommonModel.tabShow
            ? servicingCommonModel.tabShow
            : MyBookingTabShow.MyBookingTabShowEnum.Itinerary;
          // [当画面共通処理.表示タブ切り替え処理]を行う。
          this._myBookingService.onHandleCommonNo1();
        }
      }
    }

    // 22.	PNR情報取得API処理フラグ変数 = trueの場合、運賃ルール・手荷物情報取得APIを遅延ロードで実行する。
    if (this._myBookingService.PNRInfomationAquisitionFlag) {
      this.callFareConditionsPost(myBookingState, pnr);
    }
    // 23. 予約詳細store.予約情報を表示するフラグ = true とする
    this._myBookingStoreService.updateMyBooking({
      isDisplayReservation: true,
    });
    // storeの更新処理
    this._servicingCommonStoreService.updateServicingCommon({});
    // 24.
    this.setPageTitle();
    this.endOnInit();
  }

  callFareConditionsPost(myBookingState: MyBooking, pnr: GetOrderResponseData) {
    // 22.1.	リクエスト情報
    const fareConditionsApiRequest: FareConditionsRequest & ApiCommonRequest = {
      commonIgnoreErrorFlg: true,
      credential: {
        firstName: myBookingState.firstName ?? '',
        lastName: myBookingState.lastName ?? '',
      },
      orderId: pnr.orderId ?? '',
    };
    this._servicingApiService
      .fareConditionsPost(fareConditionsApiRequest)
      // 22.2.	レスポンス情報
      .subscribe({
        // 22.2.1.	正常終了の場合
        next: (res) => {
          // 予約詳細(旅程)(S01-P031)の項目を使用するために、運賃ルール・手荷物情報取得API応答を保持する。
          this._store.dispatch(updateGetFareConditions({ model: res }));
          this._myBookingService.completeFareConditionApiCall();
        },
        // 22.2.2.	異常終了の場合
      });
  }

  handleNextAction(nextAction?: NextActionTypeEnum, pnr?: GetOrderResponseData) {
    // 20.1.	次に行うアクション変数にサービシング共通store.次に行うアクションを設定する。
    // 20.3.	以下内容に従い、該当する処理を行う。
    this._nextActionService.handleNextAction(
      {
        nextAction: nextAction as string,
        firstName: this._common.aswServiceStoreService.aswServiceData.firstName!,
        lastName: this._common.aswServiceStoreService.aswServiceData.lastName!,
        orderId: pnr?.orderId!,
      },
      pnr
    );
    // 20.2.	予約詳細store.次に行うアクション実施済み有無=true(実施済み)を設定する。
    this.updateMyBooking({ nextActionImplemented: true });
  }

  /** “BAGGAGE_RULE"(手荷物ルール) */
  callbackBaggageRule(pnr?: GetOrderResponseData) {
    // 1. 予約詳細表示タブ変数≠"itinerary"(予約詳細(旅程))の場合、 予約詳細表示タブ変数に"itinerary"(予約詳細(旅程))を設定する。
    if (this._myBookingService.tabShow !== MyBookingTabShow.MyBookingTabShowEnum.Itinerary) {
      this._myBookingService.tabShow = MyBookingTabShow.MyBookingTabShowEnum.Itinerary;
    }
    // 2. [当画面共通処理No1.表示タブ切り替え処理]を行う。
    this._myBookingService.onHandleCommonNo1();
    // 3. スクロール位置を予約詳細(旅程)(S01-P031)の画面.手荷物ルールとして、スクロールを行う。
    this._myBookingItineraryService.scrollTo('my-booking-itinerary-baggage-rules-scroll');
  }

  createUnmaskedGetOrderRequest(myBookingState: MyBooking): GetOrderRequest {
    const request = {
      credential: {
        // サービス共通.姓
        firstName: myBookingState.firstName!,
        // サービス共通.名
        lastName: myBookingState.lastName!,
      },
      // false(マスキングなし)
      mask: false,
      // true(サービスカタログを取得しない)
      getServiceCatalogue: true,
      // true(予約情報を送信する)
      sendReservationInformation: true,
      // trueを設定する。
      autoAcknowledge: true,
      // trueを設定する
      repricing: true,
      // trueを設定する
      deleteHl: true,
    };
    return {
      ...request,
      // 予約詳細.予約番号がある、かつ　予約詳細.航空券番号がない場合、予約詳細.予約番号を設定する。
      // それ以外の場合、本項目を設定しない。
      ...(myBookingState?.orderId &&
        !myBookingState?.travelDocumentId && {
          orderId: myBookingState?.orderId,
        }),
      // 予約詳細.航空券番号がある場合、予約詳細.航空券番号を設定する。
      // それ以外の場合、本項目を設定しない。
      ...(myBookingState?.travelDocumentId && {
        travelDocumentId: myBookingState?.travelDocumentId,
      }),
    };
  }

  /** 7.3.2.	PNR情報取得API処理の並列処理が一つでも異常終了の場合 */
  handleGetOrderPostError(error: ApiErrorResponseModel, myBookingState?: MyBooking) {
    // ・PNR情報取得API応答が異常終了で、PNR情報取得API応答(マスキングなし)が正常終了の場合
    // 	→PNR情報取得APIのエラーを参照する
    // ・PNR情報取得API応答が異常終了で、PNR情報取得API応答(マスキングなし)が異常終了の場合
    // 	→PNR情報取得APIのエラーを参照する
    // ・PNR情報取得API応答が正常終了で、PNR情報取得API応答(マスキングなし)が異常終了の場合
    // 	→PNR情報取得API応答(マスキングなし)のエラーを参照する

    const apiErrorCode = this._common.apiError?.errors?.[0]?.code ?? '';

    if (apiErrorCode && this.errorData$?.value?.errorType !== ErrorType.SYSTEM) {
      const previousPage = this._myBookingService.getTransitionSourceFullFunctionPageId();
      const isFromList = previousPage === 'S01-P020';
      const errorMsgId = this._myBookingService.handleGetOrderPostErrorMessage({
        apiErrorCode,
        isFromList,
        aswIntTransition: !!myBookingState?.aswIntTransition,
      });

      // 7.3.2.5.	遷移元機能ID、遷移元画面IDの値に応じ、以下処理にてエラー表示先画面、および継続可否を設定する。
      // 7.3.2.5.1.	遷移元機能ID="S01"、遷移元画面ID="P010"(予約検索)または遷移元画面ID="P020"(予約一覧)の場合、以下の情報を設定する。
      // ※ASWTOPから予約検索画面(S01-P010)の初期表示処理も上記に含む。
      switch (previousPage) {
        // 7.3.2.5.1.1.	以下の値を遷移元機能ID="S01"、遷移元画面ID="P010"(予約検索)の場合、予約検索storeに保持する。
        case 'S01-P010':
          this._bookingSearchStoreService.updateBookingSearch({ errorMessageList: [{ errorMsgId, apiErrorCode }] });
          this._router.navigateByUrl(FEATURE_TO_ROUTE_MAPPING[previousPage]);
          break;
        // 7.3.2.5.1.2.	以下の値を遷移元機能ID="S01"、遷移元画面ID="P020"(予約一覧)の場合、以下の情報を設定する。
        case 'S01-P020':
          // 7.3.2.5.1.2.1. 予約詳細store.予約1件フラグ=trueの場合、予約検索storeに保持し、予約検索(S01-P010)へ遷移する。
          if (myBookingState?.is1ReservationFlg === true) {
            this._bookingSearchStoreService.updateBookingSearch({ errorMessageList: [{ errorMsgId, apiErrorCode }] });
            this._router.navigateByUrl(FEATURE_TO_ROUTE_MAPPING[previousPage]);
          }
          break;
        // 7.3.2.5.2.	上記以外の場合、以下の情報を設定する。
        default:
          this._common.errorsHandlerService.setNotRetryableError({
            errorType: ErrorType.BUSINESS_LOGIC,
            errorMsgId,
            apiErrorCode,
          });
          break;
      }
    }
    this.endOnInit();
  }

  handleCheckGetOrderError(errorMessageId: string) {
    const previousPage = this._myBookingService.getTransitionSourceFullFunctionPageId();
    switch (previousPage) {
      // 以下の値を遷移元機能ID="S01"、遷移元画面ID="P010"(予約検索)の場合、予約検索storeに保持し、予約検索(S01-P010)へ遷移する。
      case 'S01-P010':
        this._bookingSearchStoreService.updateBookingSearch({ errorMessageList: [{ errorMsgId: errorMessageId }] });
        this._router.navigateByUrl(FEATURE_TO_ROUTE_MAPPING[previousPage]);
        break;
      default:
        // 7.2.4.3.	上記以外の場合、以下の値をNotRetryableErrorStoreに保持し、共通エラー画面へ遷移する。
        this._common.errorsHandlerService.setNotRetryableError({
          errorType: ErrorType.BUSINESS_LOGIC,
          errorMsgId: errorMessageId,
        });
        break;
    }
    this.endOnInit();
  }

  /** 画面終了時処理 */
  destroy() {
    this.updateServicingCommon({
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.MYBOOKING,
    });
    // since data is global so when transition another screen and back data still exist
    this._myBookingService.tabActive = '';
    this._myBookingService.tabShow = '';
    this._subscription.unsubscribe();
  }

  /** 画面更新時処理 */
  reload() {}
}
